module.exports = __webpack_public_path__ + "static/dani-nash-619959a04e23935d0e8f7e462ec85739.gif";